import {DiseaseTreeItem} from "@/entities/diseaseParameters/DiseaseTreeItem";
import {DiseaseTreeBranchModel} from "@/entities/diseaseParameters/DiseaseTreeBranchModel";
import {DiseaseTreeLeafModel} from "@/entities/diseaseParameters/DiseaseTreeLeafModel";

export class DiseaseTree {
    rootItem: DiseaseTreeItem;

    constructor(rootItem: DiseaseTreeItem) {
        this.rootItem = rootItem;
    }

    static createFromObject(obj: any): DiseaseTree {
        const items: DiseaseTreeItem[] = [];
        if (obj.nextParameterItems) {
            for (let i = 0; i < obj.nextParameterItems.length; i++) {
                const nextItemObj = obj.nextParameterItems[i];
                const nextItem = DiseaseTreeItem.createFromObject(obj.id, 1, nextItemObj);
                items.push(nextItem);
            }
        }

        // ✅ Console log to check obj data including isViewable
        console.log('DiseaseTree.createFromObject - obj:', {
            id: obj.id,
            parameterText: obj.parameterText,
            departmentType: obj.departmentType,
            isPremium: obj.isPremium,
            isViewable: obj.isViewable,
            iconPath:obj.iconPath// ✅ NEW LOG
        });

        // ✅ Updated constructor call with isPremium, isViewable, and departmentType
        const item = new DiseaseTreeItem(
            obj.id, 
            obj.id, 
            null, 
            0, 
            obj.type, 
            obj.parameterText, 
            obj.nextParameterTitle, 
            items,
            obj.isPremium,       // isPremium
            obj.isViewable,
            obj.iconPath,   // ✅ NEW: isViewable
            obj.departmentType   // departmentType
        );

        // ✅ Console log the created item with all properties
        console.log('DiseaseTree root item created:', {
            id: item.id,
            parameterText: item.parameterText,
            departmentType: item.departmentType,
            isPremium: item.isPremium,
            isViewable: item.isViewable,  // ✅ NEW LOG
            iconPath:item.iconPath,
            nextParameterItemsCount: item.nextParameterItems.length
        });

        return new DiseaseTree(item);
    }

    toDiseaseTreeItemModel(): (DiseaseTreeBranchModel | DiseaseTreeLeafModel)[] {
        const items: (DiseaseTreeBranchModel | DiseaseTreeLeafModel)[] = [];
        if (this.rootItem && this.rootItem.nextParameterItems) {
            for (let i = 0; i < this.rootItem.nextParameterItems.length; i++) {
                const nextItem = this.rootItem.nextParameterItems[i];
                const nextItemModel = nextItem.toDiseaseTreeItemModel();
                items.push(nextItemModel);
            }
        }

        return items;
    }
}